import React from 'react';
import type { ActiveAssociateProfilePlacement } from 'src/services/associateProfile/types';
import PlacementInfo from './placementInfo';
import PlacementCardLayout from './placementCardLayout';

interface ActivePlacementCardProps {
  placement: ActiveAssociateProfilePlacement;
}

const ActivePlacementCard = ({ placement }: ActivePlacementCardProps) => (
  <PlacementCardLayout placement={placement}>
    <PlacementInfo label="Injury" value={placement.injury} />
    <PlacementInfo label="Start Date" value={new Date(placement.startAtDate).toLocaleDateString()} />
    <PlacementInfo label="End Date" value={new Date(placement.endAtDate).toLocaleDateString()} />
    <PlacementInfo label="Time In Active" value={placement.timeInActive} />
    <PlacementInfo label="Job(s)" value={placement.numSelectedJobs} />
  </PlacementCardLayout>
);

export default ActivePlacementCard;
